import { render, staticRenderFns } from "./sethead.vue?vue&type=template&id=68bb4032&scoped=true&"
import script from "./sethead.vue?vue&type=script&lang=js&"
export * from "./sethead.vue?vue&type=script&lang=js&"
import style0 from "./sethead.vue?vue&type=style&index=0&id=68bb4032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bb4032",
  null
  
)

export default component.exports